import { HttpHandlerFn, HttpEvent, HttpErrorResponse, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { ApiErrorHandlerService } from "../../services/errorHandler/api-error-handler.service";

export const ErrorInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const apiErrorService = inject(ApiErrorHandlerService);
    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            return throwError(() => apiErrorService.handle(error));
        })
    );
};